import { FilterKey } from "@studyportals/search-filters";

import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class Area extends SeoHeadingHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const selectionCount = this.selectionTypeCount(filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const areaSelected = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);

		return metaRankingSortSelected && (
			(areaSelected && selectionCount === 1) || (areaSelected && countrySelected && selectionCount === 2));
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
		
		const seoInfo = `Top Universities in ${area}, ${country} | Studyportals University Meta Ranking`;

		return Promise.resolve(seoInfo);
	}
}
